// @ts-check
import { ResourceManager } from "./resource";
import { DENSITY_SCALE } from "../global";

/**
 * Align
 */
export const Align = {
    LEFT: "left",
    RIGHT: "right",
    CENTER: "center"
};

/**
 * Rect
 */
export class Rect {
    constructor(x1, y1, x2, y2) {
        this.set(x1, y1, x2, y2);
    }

    width() {
        return this.x2 - this.x1;
    }

    height() {
        return this.y2 - this.y1;
    }

    set(x1, y1, x2, y2) {
        this.x1 = x1;
        this.y1 = y1;
        this.x2 = x2;
        this.y2 = y2;
    }
}

/**
 * Graphics
 */
export class Graphics {
    constructor(imageId) {
        // Init
        this.alpha = 1;
        this.recalcBounds = null;
        this.img = ResourceManager.image(imageId);
        this.resolutionScale = imageId.indexOf("@4x") >= 0 ? 0.25 : 1;
    }

    draw(context) {
        // Save
        context.save();

        // Set alpha
        if (this.alpha != 1) {
            context.globalAlpha = this.alpha;
        }

        // Draw image
        const b = this.getBounds();
        context.drawImage(this.img.value, b.x1, b.y1, b.width(), b.height());

        // Restore
        context.restore();
    }

    getBounds() {
        if (this.bounds == undefined) {
            // Calculate default boundary
            const w = this.img.value.width;
            const h = this.img.value.height;
            const sx = DENSITY_SCALE * w * this.resolutionScale;
            const sy = DENSITY_SCALE * h * this.resolutionScale;
            this.bounds = new Rect(-sx / 2, -sy / 2, sx / 2, sy / 2);

            // Recalc bounds function specified?
            if (this.recalcBounds) {
                this.bounds = this.recalcBounds(this.bounds);
            }
        }

        return this.bounds;
    }
}
